package com.karyadina.freesource.model

import kotlinx.serialization.Serializable

@Serializable
data class LocalizedText(
    val en: String,
    val hi: String = en // Fallback to English if Hindi is missing
) {
    fun getText(isHindi: Boolean): String = if (isHindi) hi else en
}

@Serializable
data class FreeSource(
    val id: String,
    val category: LocalizedText,
    val title: LocalizedText,
    val url: String,
    val description: LocalizedText,
    val tags: List<String> = emptyList()
)
